import React from 'react';

import BadgeStrapi from '@/decodo/components/atoms/badge/BadgeStrapi';
import { OfferCountdownStatus } from '@/decodo/components/atoms/countdown';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import RichTextFieldStrapi from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

import { BannerContentProps } from './types';
import { getWrapperMaxWidth } from '@/features/utils/utils';
import { cn } from '@/lib/utils';

export const BannerContent = ({
  bannerText,
  bannerCta,
  endDate,
  bannerBadge,
}: BannerContentProps) => {
  return (
    <div
      className={cn(
        getWrapperMaxWidth('full'),
        'max-section-width flex h-full min-h-10 w-full flex-col items-center gap-x-10 gap-y-5 md:flex-row md:gap-y-0'
      )}
    >
      <div
        className={cn(
          'flex items-center justify-end gap-3 text-center md:pl-5 md:text-left 2xl:pl-0',
          getWrapperMaxWidth('full')
        )}
      >
        {!!bannerBadge && (
          <BadgeStrapi
            block={bannerBadge}
            inner={{
              variant: 'outlined',
              colors: 'gray-200',
              size: 'l',
              classNames: {
                root: 'text-base-white hover:text-none hover:bg-transparent',
              },
            }}
          />
        )}

        <div className='text-body-l text-base-white dark:text-base-dark-white'>
          <RichTextFieldStrapi block={bannerText} />
        </div>
      </div>
      {!!endDate && <OfferCountdownStatus expiry={endDate} />}
      <div data-tracker-component='action'>
        {!!bannerCta?.text && (
          <LinkButton
            size='s'
            data-tracker-component='top-banner-cta'
            variant={bannerCta?.variant || 'text'}
            color={bannerCta?.color || 'white'}
            href={bannerCta?.url}
            showRightChevron
            classNames={{
              root: 'font-bold text-body-l hover:no-underline dark:text-base-dark-white',
            }}
          >
            {bannerCta?.text}
          </LinkButton>
        )}
      </div>
    </div>
  );
};
